/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AggiornamentoStudente } from './aggiornamentoStudente';
import { Portafogli } from './portafogli';
import { Scuola } from './scuola';

export interface Studente { 
    id?: string;
    annoDiRiferimento?: string;
    nome?: string;
    cognome?: string;
    codiceFiscale?: string;
    cittaNascita?: string;
    provinciaNascita?: string;
    dataNascita?: string;
    cittadinanza?: string;
    nonAutosufficiente?: boolean;
    isEsente?: boolean;
    isSospeso?: boolean;
    motivoEsenzione?: string;
    ordinamentoScolastico?: Studente.OrdinamentoScolasticoEnum;
    sezione?: string;
    classe?: string;
    identificativoMenuExtra?: string;
    dietaAlternativa?: string;
    religione?: string;
    note?: string;
    scuola?: Scuola;
    isPresenteRicaricaDaPagare?: boolean;
    giorniResiduiSospensioneServizio?: number;
    portafogli?: Portafogli;
    aggiornamenti?: Array<AggiornamentoStudente>;
    created_at?: Date;
    updated_at?: Date;
}
export namespace Studente {
    export type OrdinamentoScolasticoEnum = 'SCUOLA_INFANZIA' | 'PRIMARIA';
    export const OrdinamentoScolasticoEnum = {
        SCUOLAINFANZIA: 'SCUOLA_INFANZIA' as OrdinamentoScolasticoEnum,
        PRIMARIA: 'PRIMARIA' as OrdinamentoScolasticoEnum
    };
}